import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "left transport tabsUp"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_lokacija-priljubljena" }, null, -1)
const _hoisted_4 = { class: "flex where" }
const _hoisted_5 = {
  key: 0,
  class: "stationList"
}
const _hoisted_6 = { class: "stationNumber" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 1,
  class: "map"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col1_3 sideBar right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapCustom = _resolveComponent("MapCustom")!
  const _component_SidebarWrapper = _resolveComponent("SidebarWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarWrapper, {
    sidebarComponent: _ctx.sidebarComponent,
    mapComponent: _ctx.mapComponent,
    sidebarLeft: true
  }, {
    default: _withCtx(() => [
      (_ctx.station)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.station.name) + " ", 1),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.station.code), 1)
            ]),
            (_ctx.station.arrivals)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.station.arrivals, (route) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "stationName",
                      key: route
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(route.route_name), 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(route.short_name), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.marker !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_MapCustom, {
                    center: _ctx.marker.position,
                    markers: [_ctx.marker]
                  }, null, 8, ["center", "markers"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["sidebarComponent", "mapComponent"]))
}